import { Typography, Box, styled } from '@mui/material';
import { AdminUserRealm } from 'further-types/admin-user';
import EisRoutes from './RouteSetup/EisRoutes';
import LpRoutes from './RouteSetup/LpRoutes';
import PageLoader from 'components/PageLoader';
import useAuth from 'hooks/auth/useAuth';
import DownloadTrayContainer from 'components/DownloadTrayContainer';
import VehicleSelectionGate from 'layouts/OldLayout/VehicleSelectionGate';
import Button from 'components/Button';
import Row from 'components/Layout/Row';

const Logo = styled('img')({
  height: '24px',
});

const Routes: React.FC = () => {
  const { isLoading, realm, actionableError, loginWithRedirect, logout } =
    useAuth();

  if (actionableError) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        gap={6}
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Logo src="images/logo.png" alt="Further" />
        <Typography>{actionableError}</Typography>
        <Row spacing="sm">
          <Button
            variant="outlined"
            onClick={() => {
              loginWithRedirect({
                appState: {
                  returnTo: '/',
                },
              });
            }}
          >
            Retry
          </Button>
          <Button variant="outlined" onClick={() => logout()}>
            Logout
          </Button>
        </Row>
      </Box>
    );
  }

  if (isLoading) {
    return <PageLoader />;
  }

  if (realm === AdminUserRealm.Lp) {
    return (
      <VehicleSelectionGate>
        <LpRoutes />
      </VehicleSelectionGate>
    );
  }

  if (realm === AdminUserRealm.Eis || realm === AdminUserRealm.Super) {
    return (
      <>
        <EisRoutes />
        <DownloadTrayContainer />
      </>
    );
  }
  return null;
};

export default Routes;
